import { ReactElement } from 'react';

import {
  Alert,
  Calendar,
  ClipboardList,
  Edit,
  Flag,
  FlagOutline,
  SVGProps,
  Task,
  User,
} from '@equip.health/ui';

export enum ActivityField {
  ASSIGNEE_NAME = 'assigneeName',
  CATEGORY_NAME = 'categoryName',
  CLOSED_OR_VOID_REASON = 'voidReason',
  CREATED = 'created',
  TASK_DUE_DATE = 'taskDueDate',
  PATIENT_NAME = 'patientName',
  PRIORITY_ID = 'priorityId',
  STATUS_ID = 'statusId',
  SUBCATEGORY_NAME = 'subCategoryName',
  TASK_NAME = 'taskName',
}

export enum OrganizeBy {
  CREATED_DATE = 'created-date',
  DUE_DATE = 'due-date',
  PATIENT = 'patient',
  PRIORITY_SCORE = 'priority-score',
  CATEGORY = 'category',
}

export type SVGElementType = (props: SVGProps) => ReactElement<SVGProps, 'svg'>;

type ActivityFieldInfo = {
  name: string;
  icon: SVGElementType;
};

export const activityFieldMapper: Record<ActivityField, ActivityFieldInfo> = {
  [ActivityField.ASSIGNEE_NAME]: {
    icon: User,
    name: 'Assignee',
  },
  [ActivityField.CATEGORY_NAME]: {
    icon: ClipboardList,
    name: 'Category',
  },
  [ActivityField.CLOSED_OR_VOID_REASON]: {
    icon: Alert,
    name: 'Closed/void reason',
  },
  [ActivityField.CREATED]: {
    icon: FlagOutline,
    name: 'Created',
  },
  [ActivityField.TASK_DUE_DATE]: {
    icon: Calendar,
    name: 'Due date',
  },
  [ActivityField.PATIENT_NAME]: {
    icon: User,
    name: 'Patient',
  },
  [ActivityField.PRIORITY_ID]: {
    icon: Flag,
    name: 'Priority',
  },
  [ActivityField.STATUS_ID]: {
    icon: Task,
    name: 'Status',
  },
  [ActivityField.SUBCATEGORY_NAME]: {
    icon: ClipboardList,
    name: 'Sub-category',
  },
  [ActivityField.TASK_NAME]: {
    icon: Edit,
    name: 'Title',
  },
};

export const NULL_USER_NAME = 'null null';
export const CATEGORY_PATIENT_CARE = 'Patient care';
export const SUBCATEGORY_DOCUMENTS = 'Documents';
export const DOWNLOAD_LAB_REQUEST_FORM = 'Download lab request form';
export const HG_LAB_RESULTS = 'hg lab results';

export const CREATE_TASK_SOURCES = {
  ACTION_MENU: 'ACTION MENU',
  INQUIRY_DETAIL: 'INQUIRY DETAIL',
  DISCHARGE_PLAN_VIEW: 'DISCHARGE PLAN VIEW',
  CREATE_NEW_BUTTON: 'CREATE NEW BUTTON',
  TASKS_LIST_PANEL: 'TASKS LIST PANEL',
} as const;

export type CreateTaskSource =
  (typeof CREATE_TASK_SOURCES)[keyof typeof CREATE_TASK_SOURCES];
